import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { FIELD_DATA, FETCHED_OBJECT_PROPERTY, ENROLLMENT_EVENT_PROPERTY, ENROLLMENT_DATASET_COLUMN } from 'automation-ui-formula-editor/formula-editor/data-passing/constants/DataSourceOptions';
import StaticBranchActionDetailFromDataToken from 'automation-ui-action-features/actions/static-branch/StaticBranchActionDetailFromDataToken';
import getInputTypeDefinition from 'automation-ui-action-features/action-outputs/utils/getInputTypeDefinition';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StaticBranchActionExplainer({
  action,
  flowObjectTypeId,
  getActionLabelById,
  getActionOutputsForTargetActionById
}) {
  const metadata = action.metadata;
  const inputType = metadata.getInputType();
  if (inputType === FETCHED_OBJECT_PROPERTY || inputType === ENROLLMENT_EVENT_PROPERTY || inputType === ENROLLMENT_DATASET_COLUMN) {
    const token = metadata.getInputValue().getPropertyToken();
    return /*#__PURE__*/_jsx(StaticBranchActionDetailFromDataToken, {
      langKey: "automation-ui-action-features.action-features.static-branch.explainer.fetched-object",
      token: token
    });
  } else if (inputType === FIELD_DATA) {
    const sourceActionId = metadata.getValueIdentifierActionId();
    const outputDefinition = getInputTypeDefinition({
      sourceActionId: sourceActionId,
      sourceOutputName: metadata.getValueIdentifierDataKey(),
      actionOutputs: getActionOutputsForTargetActionById(action.getActionId(), false)
    });
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.static-branch.explainer.data-passing",
      options: {
        sourceActionName: sourceActionId ? /*#__PURE__*/_jsx("strong", {
          children: getActionLabelById({
            actionId: sourceActionId
          })
        }) : /*#__PURE__*/_jsx(MissingLabel, {
          type: "action"
        }),
        actionOutcomeName: outputDefinition ? /*#__PURE__*/_jsx("strong", {
          children: outputDefinition.label
        }) : /*#__PURE__*/_jsx(MissingLabel, {
          type: "value"
        })
      }
    });
  } else {
    const propertyName = metadata.getInputValue().getPropertyName();
    return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.static-branch.explainer.enrolled-object_cob",
      objectTypeId: flowObjectTypeId,
      options: {
        sourcePropertyName: /*#__PURE__*/_jsx(PropertyName, {
          propertyName: propertyName,
          objectTypeId: flowObjectTypeId
        })
      }
    });
  }
}